<template>
  <div class="qualificationApplication">
    <div>
      <personalHeadSeal
        title="印章"
        :hide="true"
        :back="disabled"
        @goBack="goBack"
      />
      <div class="form">
        <el-form
          :model="ruleForm"
          status-icon
          :rules="rules"
          ref="ruleForm"
          label-width="200px"
          class="demo-ruleForm"
        >
          <el-row :gutter="20">
            <el-col :xs="24" :sm="24" :md="24">
              <el-form-item label="印章" :error="error" :required="true">
                <el-upload
                  class="avatar-uploader center"
                  action="#"
                  accept=".png, .jpeg, .jpg"
                  :auto-upload="false"
                  :multiple="false"
                  :show-file-list="false"
                  :on-change="loadJsonFromFile"
                  :disabled="disabled"
                >
                  <img
                    v-if="imageUrl"
                    :src="imageUrl"
                    class="avatar"
                    @mouseover="imgMouseover"
                  />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  <div
                    class="el-upload-show"
                    :style="active"
                    @mouseleave="imgMouseleave"
                  >
                    <span class="el-upload-span1">
                      <span
                        class="el-upload-list__item-preview"
                        @click.stop="handlePictureCardPreview()"
                      >
                        <i class="el-icon-zoom-in"></i>
                      </span>
                      <span
                        @click.stop="handleRemove()"
                        v-if="!formInfo.business_license_key"
                      >
                        <i class="el-icon-delete"></i>
                      </span>
                    </span>
                  </div>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible">
                  <img width="100%" :src="dialogImageUrl" alt />
                </el-dialog>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24">
              <el-form-item class="submit">
                <el-button
                  @click="goBack('ruleForm')"
                  plain
                  type="danger"
                  v-if="disabled"
                  >返 回</el-button
                >
                <el-button
                  type="danger"
                  @click="save('ruleForm')"
                  :loading="loading"
                  v-if="!disabled"
                  >提 交</el-button
                >
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import personalHeadSeal from "@/views/admin/components/personalHeadSeal.vue";
import {
  CreateQualifications,
  GetTestQualificationsDetails,
  GetAddsignature,
} from "@/api/admin/test.js";
import { GetDicData, GetDistrictList } from "@/api/admin/common.js";
import { mapGetters } from "vuex";
let that;
export default {
  components: {
    personalHeadSeal,
  },
  computed: {
    ...mapGetters(["personalInfo"]),
  },
  data() {
    return {
      ruleForm: {
        bidlevel: [],
        insQua: [],
        credit: [],
        equipment: [],
        PerManage: [],
        pubPromotion: [],
        agree: [],
      },
      formInfo: {},
      form: {},
      formList: [],
      isShow: true,
      rules: {
        business_license_key: [
          { required: true, message: "请上传印章", trigger: "blur" },
        ],
      },
      disabled: false,
      loading: false,
      uploadFiles: [],
      localFile: {},
      error: "",
      error1: "",
      dialogVisible: false,
      dialogImageUrl: "",
      active: "",
      imageUrl: "",

      province: [],
      city: [],
      district: [],
      imgPath: window.apiObj.apiUrl,
    };
  },
  created() {
    this.imageUrl = this.personalInfo.business_license_key;
    this.dicDa();
    this.getList();
  },
  watch: {},
  methods: {
    getList() {},
    dicDa() {},
    apply() {
      this.isShow = true;
    },
    goBack() {
      this.isShow = false;
    },
    save(ruleForm) {
      this.form.isFormSubmit = true;
      this.form.business_license_key = this.localFile;

      if (!this.imageUrl) {
        this.error = "请上传印章";
      } else {
        this.error = "";
      }

      this.$refs[ruleForm].validate((valid) => {
        if (valid) {
          this.loading = true;
          GetAddsignature(this.form)
            .then((data) => {
              var dataResult = data.data.result;
              if (dataResult.code == 1 || dataResult.code == "1") {
                this.$message({
                  message: "上传成功",
                  type: "success",
                });
              } else {
                this.$message({
                  message: dataResult.msg,
                  type: "success",
                });
              }
              this.loading = false;
            })
            .catch(() => {
              this.loading = false;
            });
        } else {
          return false;
        }
      });
    },

    handlePictureCardPreview() {
      this.dialogVisible = true;
      this.dialogImageUrl = this.imageUrl;
    },
    handleRemove() {
      this.imageUrl = "";
      this.localFile = {};
      this.active = "display:none;opacity: 0;";
    },
    loadJsonFromFile(file) {
      this.localFile = file.raw;
      let reader = new FileReader();
      reader.readAsDataURL(this.localFile);
      reader.onload = () => {
        const isJPG =
          this.localFile.type === "image/jpeg" ||
          this.localFile.type === "image/png";
        const isLt4M = this.localFile.size / 1024 / 1024 < 4;
        if (!isJPG) {
          this.localFile = {};
          this.$message.error("上传印章只能是 JPG/PNG 格式!");
        } else {
          this.imageUrl = reader.result;
        }
        if (!isLt4M) {
          this.$message.error("上传印章大小不能超过 4MB!");
        }
        return isJPG && isLt4M;
      };
    },
    imgMouseover() {
      this.active = "display:block;opacity: 1;";
    },
    imgMouseleave() {
      this.active = "display:none;opacity: 0;";
    },
  },
  beforeCreate: function () {
    that = this;
  },
};
</script>
<style lang="less">
.qualificationApplication {
  .form {
    width: 90%;
    .el-form-item__label {
      padding-right: 42px;
      font-size: 14px;
      font-weight: 400;
    }
    .el-textarea__inner {
      min-height: 150px !important;
      font-family: "微软雅黑";
    }
    .agree .el-checkbox__input {
      position: relative;
      top: -20px;
    }
    .border {
      .el-input__inner {
        border-width: 0px !important;
      }
    }
    .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #409eff;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 178px;
      height: 178px;
      line-height: 178px;
      text-align: center;
    }
    .avatar {
      width: 178px;
      height: 178px;
      display: block;
    }
    .el-upload-show {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      text-align: center;
      color: #fff;
      opacity: 0;
      display: none;
      font-size: 20px;
      background-color: rgba(0, 0, 0, 0.5);
      transition: opacity 0.3s;
      line-height: 9;
      .el-upload-span1 {
        span {
          padding: 0px 20px;
        }
      }
    }
  }
  .quaul {
    width: 65%;
    padding: 5% 10px 10% 10px;
    .apply {
      padding: 10px 30px 10px 0px;
      text-align: right;
    }
    ul {
      li {
        height: 40px;
        line-height: 40px;
        .qast-sp1 {
          display: inline-block;
          width: 40%;
          text-align: right;
          color: #888;
        }
        @media screen and (max-width: 500px) {
          .qast-sp1 {
            width: 30% !important;
          }
        }
        .qast-sp2 {
          margin-left: 50px;
          color: #444;
        }
      }
    }
  }
  .el-page-header {
    padding: 5px 20px;
  }
  @media screen and (max-width: 1024px) {
    .quaul {
      width: 100% !important;
    }
  }
  @media screen and (max-width: 500px) {
    .form {
      width: 100% !important;
      .el-form-item__label {
        width: 110px !important;
        float: none;
      }
      .el-form-item__content {
        margin-left: 0px !important;
        float: none;
      }
      .center {
        text-align: center;
      }
      .content {
        .el-form-item__content {
          margin-left: 0px !important;
        }
      }
    }
  }
}
</style>
